import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const FindNearestSection: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(18),
    textAlign: 'center',
    margin: pxArrayToRem([13, 8, 8, 0]),
    minHeight: pxToRem(38),

    [theme.screen.laptop]: {
        minHeight: 'unset',
        textAlign: 'right',
        fontSize: pxToRem(18),
        margin: pxArrayToRem([0, 10, 0, 0]),
    },

    [`& .${buttonClassName}`]: {
        padding: 0,
        color: theme.siteVariables.colorScheme.default?.foreground,
        marginBottom: 0,

        '&:hover': {
            textDecoration: 'unset',
        },

        [`& .${labelClassName}`]: {
            textDecoration: 'underline',
            color: theme.siteVariables.colorScheme.default?.foreground,

            [theme.screen.laptop]: {
                textDecoration: 'unset',
            },
        },
    },
});

export const FindNearestText: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.danger[100],

    fontSize: pxToRem(14),
    lineHeight: '125%',
    textAlign: 'center',
    margin: pxArrayToRem([11, 45, 7, 52]),
    letterSpacing: theme.siteVariables.letterSpacingNormal,

    [theme.screen.laptop]: {
        fontSize: pxToRem(18),
        lineHeight: theme.siteVariables.lineHeightDefault,
        textAlign: 'left',
        margin: pxArrayToRem([17, 0, 7, 0]),
    },
});
